import React from 'react'
import { Tab, styled } from '@mui/material'

export const TabLabelWrapper = styled('span')`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: ${({ float }) => (float ? '0' : '8px')};
`

export const TabBadge = styled('span')`
  position: ${({ float }) => (float ? 'absolute' : 'relative')};
  top: ${({ float }) => (float ? '-14px' : '0')};
  right: ${({ float }) => (float ? '-10px' : '0')};
  font-size: 10px;
  font-weight: 600;
  line-height: 1;
  padding: 3px 6px;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.palette?.primary?.black2 ?? '#536479'};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  color: #fff;
  white-space: nowrap;
`

export const Root = styled(({ align, display, isSelected, padding, width, ...props }) => <Tab {...props} />)`
  &.MuiTab-root {
    border-left: ${({ isSelected, theme }) => (isSelected ? `2px solid ${theme.palette.blue[50]}` : '')};
    border-radius: 4px;
    border-bottom-left-radius: ${props => (props.isSelected ? '0' : '4px')};
    border-top-left-radius: ${props => (props.isSelected ? '0' : '4px')};
    color: ${({ isSelected, theme }) => (isSelected ? theme.palette.blue[50] : theme.palette.gray[50])};
    display: ${props => props.display};
    font-size: 14px;
    font-weight: bold;
    line-height: 22px;
    min-width: ${props => props.width || '110px'};
    opacity: 1;
    padding: ${props => props.padding || '6px 18px'};
    text-transform: inherit;
    width: ${props => props.width};
  }

  .MuiTab-wrapper {
    align-items: ${({ align }) => {
      switch (align) {
        case 'left':
          return 'flex-start'
        case 'right':
          return 'flex-end'
        case 'center':
        default:
          return 'center'
      }
    }};
  }

  &:hover {
    background-color: ${props => props.theme.palette.custom.gray[50.1]};
    text-decoration: none;
  }

  &.Mui-selected {
    color: ${props => props.theme.palette.blue[50]};
  }
`

export const LoadingWrapper = styled('div')`
  align-items: center;
  display: flex;
  height: 48px;
  width: 120px;
`
